import { Navigate,useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({children,allowedRoles=[]}){
  const {user,loading}=useAuth();
  const location=useLocation();

  if(loading) return null;
  if(!user) return <Navigate to="/admin-login" replace />;

  if(user.rol==="DELEGADO"&&user.must_change_password&&location.pathname!=="/actualizar-clave"){
    return <Navigate to="/actualizar-clave" replace />;
  }

  if(user.rol==="DELEGADO"&&!user.must_change_password&&location.pathname==="/actualizar-clave"){
    return <Navigate to="/delegado" replace />;
  }

  if(allowedRoles.length&&!allowedRoles.includes(user.rol)){
    if(user.rol==="DELEGADO") return <Navigate to={user.must_change_password?"/actualizar-clave":"/delegado"} replace />;
    if(user.rol==="ADMIN"||user.rol==="SUPERADMIN") return <Navigate to="/admin" replace />;
    return <Navigate to="/" replace />;
  }

  return children;
}